import { createContext, useContext, useState, type ReactNode } from 'react'

interface ProfileModalContextValue {
  isOpen: boolean
  openProfileModal: () => void
  closeProfileModal: () => void
}

const ProfileModalContext = createContext<ProfileModalContextValue>({
  isOpen: false,
  openProfileModal: () => {},
  closeProfileModal: () => {},
})

export function ProfileModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <ProfileModalContext.Provider value={{
      isOpen,
      openProfileModal: () => setIsOpen(true),
      closeProfileModal: () => setIsOpen(false),
    }}>
      {children}
    </ProfileModalContext.Provider>
  )
}

export function useProfileModal() {
  return useContext(ProfileModalContext)
}
